import { TextField } from "@mui/material";
import { TagCellContext } from "./types";

export function TagRank({ row, isEditing, setIsEditing, updateTag, onSave }: TagCellContext<number>) {
  const editing = isEditing(row.id);
  const tag = row.original;
  const displayRank = tag.tempRank !== undefined ? tag.tempRank : tag.rank;

  return (
    <span
      className="w-full justify-between inline-flex items-center gap-1"
      onClick={() => !editing && setIsEditing(row.id)}>
      {editing ? (
        <TextField
          variant="standard"
          className="bg-white p-0 focus:ring-peri-300"
          value={displayRank}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSave(tag);
            }
          }}
          onChange={(e) => {
            const asNumber = Number(e.target.value);
            if (isNaN(asNumber)) return;
            updateTag({
              ...tag,
              // Changing the actual rank immediately is jarring as the row jumps around
              tempRank: asNumber,
            });
          }}
        />
      ) : (
        <span className="py-1">{displayRank}</span>
      )}
    </span>
  );
}
